/**
 * IMatchFormationData interfaces and types
 */
export interface IMatchFormationData {
  goals?: Array<IMatchScoreEvent>;
  scorersCards?: Array<IMatchScoreEvent>;
  substitution?: Array<IMatchSubstitution>;
  topPlayerId?: number | null;
}

export interface IMatchSubstitution {
  minutes: number;
  playerIdIn: number;
  playerIdOut: number;
}

export interface IMatchScoreEvent {
  id: number;
  minutes: number;
  type: GoalType | ScorersCardsType;
}

/* Notes:
 * goals' types: GOAL, PENALTY, OWN
 */
export type GoalType = 'GOAL' | 'OWN' | 'PENALTY';

export const GOAL: GoalType = 'GOAL';
export const OWN: GoalType = 'OWN';
export const PENALTY: GoalType = 'PENALTY';

export const GoalTypeList: GoalType[] = [GOAL, OWN, PENALTY];

/* Notes:
 * scorersCards' types: YELLOW, RED, REDONYELLOW
 */
export type ScorersCardsType = 'YELLOW' | 'RED' | 'REDONYELLOW';

export const RED: ScorersCardsType = 'RED';
export const YELLOW: ScorersCardsType = 'YELLOW';
export const REDONYELLOW: ScorersCardsType = 'REDONYELLOW';

export const ScorersCardsTypeList: ScorersCardsType[] = [RED, YELLOW, REDONYELLOW];
